export function safePush(router, location) {
  const path = typeof location === 'string' ? location : location.path;
  if (router.currentRoute.path !== path) {
    return router.push(location);
  }
  return Promise.resolve();
}